module.exports = __webpack_public_path__ + "img/piliangchuli.5005e7a1.png";